import ajax from '../assets/js/ajax'
const state = {
  curUser: null
}
const actions = {
  saveJob (ctx, params) {
    return ajax.post('/zhaopin/b/job/save.json', params)
  },
  publishJob (ctx, params) {
    return ajax.post('/zhaopin/b/job/save.json', params)
  },
  getJobById (ctx, params) {
    return ajax.get('/zhaopin/b/job/info.json', params)
  },
  listJob (ctx, params) {
    return ajax.get('/zhaopin/b/job/list.json', params)
  },
  changeJobStatus (ctx, params) {
    return ajax.post('/zhaopin/b/job/over.json', params)
  }
}
const mutations = {

}
export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/job.js